// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BXAq2ENWjhPnlr9YGV0f{width:100%;height:100%;cursor:grab;transition:opacity .3s}.BXAq2ENWjhPnlr9YGV0f>*{width:100%;height:100%}.BXAq2ENWjhPnlr9YGV0f.SmdcxNq48AEHfISxB2E2{cursor:grabbing}.BXAq2ENWjhPnlr9YGV0f.OSvtEt22RXAIHvMpU7GX{opacity:.4}.BXAq2ENWjhPnlr9YGV0f .aVWFl3pD_fpUJ0gGWUQz{cursor:copy}.BXAq2ENWjhPnlr9YGV0f .cGwy0KyAkU06A_MlanQl{display:inline-flex}.BXAq2ENWjhPnlr9YGV0f .WiT4ms6QBM4BnAexgPLY{margin-left:6px;height:100%;line-height:16px;cursor:pointer}.BXAq2ENWjhPnlr9YGV0f .WiT4ms6QBM4BnAexgPLY:hover i{color:var(--color-515-pomarancz)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `BXAq2ENWjhPnlr9YGV0f`,
	"dragging": `SmdcxNq48AEHfISxB2E2`,
	"draggingOther": `OSvtEt22RXAIHvMpU7GX`,
	"canDrop": `aVWFl3pD_fpUJ0gGWUQz`,
	"content": `cGwy0KyAkU06A_MlanQl`,
	"closeButton": `WiT4ms6QBM4BnAexgPLY`
};
export default ___CSS_LOADER_EXPORT___;
